import { Dictionary } from "../../sys/Dictionary";

import StatData from "./../../../assets/json/stat_key_map.json";

export const StatKeyMap: Dictionary<string, string> = new Dictionary<
    string,
    string
>(StatData);
